const LegalNotice = <div></div>;

export default LegalNotice;
